import { defineAbility } from '@casl/ability'

import { User } from '../../../models'
import { Roles, userHasRole } from '../../../helpers'

export default (user: User) => defineAbility((can) => {
    if (userHasRole(user, Roles.Standard)) {
        can('Create', 'SupplierAddress')
        can('Edit', 'SupplierAddress')
        can('Delete', 'SupplierAddress')
        can('Update', 'SupplierAddress')
    }
})
